import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButtonProps } from 'react-toastify';

const DefaultCloseButton = ({ closeToast }: CloseButtonProps) => {
  const { t } = useTranslation();
  return (
    <button
      data-testid="default-close-button"
      className="text-sm font-semibold p-2 capitalize"
      onClick={closeToast}
    >
      {t('commons.ok').toLowerCase()}
    </button>
  );
};

export default DefaultCloseButton;
